import { RelationType } from '../types';

export function formatSiretDisplay(siret: string | null | undefined): string {
  if (!siret) return '';
  const s = String(siret).replace(/\D/g, '');
  if (s.length !== 14) return siret;
  return `${s.substring(0, 3)} ${s.substring(3, 6)} ${s.substring(6, 9)} ${s.substring(9, 14)}`;
}

export function formatDate(dateStr: string | null | undefined): string {
  if (!dateStr) return '-';
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  } catch (e) {
    return dateStr;
  }
}

export function formatDateTime(dateTimeStr: string | null | undefined): string {
  if (!dateTimeStr) return '-';
  try {
    const d = new Date(dateTimeStr);
    if (isNaN(d.getTime())) return dateTimeStr;
    return d.toLocaleString('fr-FR', { 
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  } catch (e) {
    return dateTimeStr;
  }
}

export function formatRelationType(type: RelationType | string): string {
  switch (type) {
    case 'perso': return 'Relation Personnelle';
    case 'fournisseur': return 'Fournisseur';
    case 'prestataire': return 'Prestataire';
    case 'conseil': return 'Conseil';
    default: return type;
  }
}

export function escapeHtml(str: string | null | undefined): string {
  if (!str) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}
